<template>
  <div class="footer">
    <p class="relate-link">
        <a href="http://www.wanfang.com.cn/index.html" target="_blank">公司首页 </a>
        <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
        <a href="http://www.wanfangdata.com.cn/index.html" target="_blank">万方数据知识服务平台</a>
        <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
        <a href="http://cpc.wanfangdata.com.cn/index.do" target="_blank">公共文化知识服务平台</a>
        <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
        <a href="https://w.wanfangdata.com.cn/Customer" target="_blank">客户服务</a>
    </p>
     <p class="info">
       <a style="cursor:text">客服电话：4000115888 </a>
      <a style="cursor:text">客服邮箱：service@wanfangdata.com.cn</a>
      <br>
      <a href="https://ad.wanfangdata.com.cn/images/icp.jpg" target="_blank">京ICP证：010071</a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802020237" target="_blank">京公网安备11010802020237号</a>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP备08100800号-1</a>
    </p>
    <p class="info">
      <a href="https://ad.wanfangdata.com.cn/images/hlwcb.jpg" target="_blank">网络出版服务许可证：（署）网出证（京）字第072号</a>&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="https://ad.wanfangdata.com.cn/images/stjmxkz3.jpg" target="_blank">信息网络传播试听节目许可证 许可证号：0108284</a>&nbsp;&nbsp;&nbsp;&nbsp;
      <br>
      <a style="cursor:text">违法和不良信息举报电话：4000115888 </a>
      <a style="cursor:text">举报邮箱：problem@wanfangdata.com.cn </a>
      <a href="https://www.12377.cn" target="_blank">举报专区：https://www.12377.cn </a>
      <br>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="less" scoped>
.footer{
    font-size: 14px;
    text-align: center;
    margin-top: 50px;
    background: #e4e1dc;
    color: #847864;
    p {
      a{
        margin: 0 5px;
        color: #847864;
      }
    }
    .relate-link{
      margin: 0 0 35px;
      padding-top: 42px;
      a{
        text-decoration: none;
        margin: 0 15px;
        color: #847864;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/common/Footer.vue